import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AccessType } from '@classes/access-type';
// import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { EnvConfigurationService } from './env-configuration.service';

@Injectable({
  providedIn: 'root'
})
export class AccessTypeService {
  environment = this.envConfigurationService.environment;

  private basePath = this.environment.apiUrl + '/accessType';

  constructor(
    private http: HttpClient,
    public envConfigurationService: EnvConfigurationService
  ) { }

  getAccessTypes(): Observable<Array<AccessType>> {
    return this.http.get<Array<AccessType>>(this.basePath);
  }
  createOrUpdateAccessType(accessType?: AccessType): Observable<AccessType> {
    if (accessType?.id) {
      //update
      const url = `${this.basePath}/${accessType?.id}`;
      return this.http.patch<any>(url,
        accessType).pipe(map(m => {
          return m
        }));
    } else {
      //create
      return this.http.post<any>(this.basePath,
        accessType
      ).pipe(map(m => {
        return m
      }));
    }
  }
}
